import React, { useEffect, useState } from 'react';
import MigrateContactDialog from './MigrateContactDialog';
import useContact from 'src/hooks/api/useContact';
import Contact, { CreateContactOptions, LegacyContact } from 'src/interfaces/api/Contact';
import useSite from 'src/hooks/api/useSite';
import { Backdrop, CircularProgress } from '@material-ui/core';

interface Props {
  siteId: string;
  open: boolean;
  onClose: () => void;
  onValidate: (contactOptions: CreateContactOptions) => void;
  legacyContact: LegacyContact;
}

const MigrateContactDialogContainer: React.FC<Props> = ({ open, siteId, onClose, onValidate, legacyContact }) => {
  const { getByLegacyId } = useContact();
  const { addContact } = useSite();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (legacyContact.id) {
      setLoading(true);

      getByLegacyId(legacyContact.id)
        .then((contact: Contact) => {
          addContact(siteId, contact.id)
            .then(() => {
              location.reload();
            })
            .catch((e) => {
              alert(e.message);
              setLoading(false);
            });
        })
        .catch(() => {
          setLoading(false);
        });
    }
  }, []);

  return (
    <>
      <Backdrop style={{ zIndex: 10000, color: 'white' }} open={open && loading}>
        <CircularProgress color='inherit' />
      </Backdrop>

      <MigrateContactDialog
        open={open && !loading}
        siteId={siteId}
        onClose={onClose}
        onValidate={onValidate}
        legacyContact={legacyContact}
      />
    </>
  );
};

export default MigrateContactDialogContainer;
